/* Hero gallery + bundle selection. Flavour handling lives in nadiri-nad-flavour.js. */
(function () {
  'use strict';
  function boot() {
    var root = document.querySelector('[data-nn-hero]');
    if (!root) return;

    var mains = root.querySelectorAll('[data-nn-main]');
    var thumbs = root.querySelectorAll('[data-nn-thumb]');
    var idx = 0;

    function show(i) {
      if (!mains.length) return;
      idx = (i + mains.length) % mains.length;
      mains.forEach(function (m, n) { m.style.display = n === idx ? '' : 'none'; });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === idx ? 'true' : 'false'); });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.dataset.nnThumb, 10)); });
    });
    var prev = root.querySelector('[data-nn-prev]');
    var next = root.querySelector('[data-nn-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });

    var gal = root.querySelector('[data-nn-gallery]');
    if (gal) {
      gal.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); }
      });
      var tx = null;
      gal.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      gal.addEventListener('touchend', function (e) {
        if (tx === null) return;
        var dx = e.changedTouches[0].clientX - tx;
        if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
        tx = null;
      }, { passive: true });
    }

    // Bundle selection. Broadcasts so the final CTA and sticky bar follow.
    root.querySelectorAll('[data-nn-opt]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        root.querySelectorAll('[data-nn-opt]').forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
        opt.setAttribute('aria-checked', 'true');
        var input = root.querySelector('[data-nn-variant-input]');
        var priceEl = root.querySelector('[data-nn-cta-price]');
        if (input) input.value = opt.dataset.variantId;
        if (priceEl) priceEl.textContent = opt.dataset.variantPrice;
        document.dispatchEvent(new CustomEvent('nn:variant', {
          detail: { id: opt.dataset.variantId, price: opt.dataset.variantPrice, name: opt.dataset.variantName }
        }));
      });
    });

    document.addEventListener('nn:variant', function (e) {
      var input = root.querySelector('[data-nn-variant-input]');
      var priceEl = root.querySelector('[data-nn-cta-price]');
      if (input) input.value = e.detail.id;
      if (priceEl) priceEl.textContent = e.detail.price;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
